import { render, staticRenderFns } from "./PlafondsEdit.vue?vue&type=template&id=097d261a&"
import script from "./PlafondsEdit.vue?vue&type=script&lang=js&"
export * from "./PlafondsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports